import { render, staticRenderFns } from "./unsaved_changes_alert.vue?vue&type=template&id=79bc17dc&lang=pug&"
import script from "./unsaved_changes_alert.vue?vue&type=script&lang=js&"
export * from "./unsaved_changes_alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports